import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { HELP_DESK_URL } from '../../constants/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HelpDeskInterceptAlert = ({
  onDismiss,
  onClickGoToHelpDesk
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "help-desk-intercept-alert",
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-conversations-settings-lib.helpDeskOnboarding.helpDeskIntercept.alert.title"
    }),
    closeable: true,
    onClose: onDismiss,
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "svh-conversations-settings-lib.helpDeskOnboarding.helpDeskIntercept.alert.description"
      }), /*#__PURE__*/_jsx(Button, {
        size: "extra-small",
        use: "tertiary",
        href: HELP_DESK_URL,
        onClick: onClickGoToHelpDesk,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "svh-conversations-settings-lib.helpDeskOnboarding.helpDeskIntercept.alert.button"
        })
      })]
    })
  });
};
HelpDeskInterceptAlert.displayName = 'HelpDeskInterceptAlert';